import { FunctionComponent } from "react";

import Group from "./components/Group";
import GroupItem from "./components/GroupItem";
import Item from "./components/Item";

interface SubComponents {
  Group: typeof Group;
  GroupItem: typeof GroupItem;
  Item: typeof Item;
}

const AccordionMenu: FunctionComponent<{ children: React.ReactNode }> &
  SubComponents = ({ children }) => {
  return <ul>{children}</ul>;
};

AccordionMenu.Item = Item;
AccordionMenu.Group = Group;
AccordionMenu.GroupItem = GroupItem;

export default AccordionMenu;
